import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilter from "./SelectFilter";

const SelectFilterCategory = ({
  store,
  categoryId = 0,
  onCategoryChange,
  languageContext,
  sx,
}) => {
  const ancestors = [];
  for (
    let cat = categoryId;
    cat && store.categories[cat];
    cat = store.categories[cat]?.parentId
  ) {
    ancestors.unshift(cat);
  }
  ancestors.unshift(0);

  const selects = ancestors.map((ancestorId, i) => {
    const children = store.categoryHierarchy[ancestorId] || [];
    if (!children.length) return null;
    const selected = ancestors[i + 1] || 0;

    return (
      <BaseGrid direction="column">
        <SelectFilter
          key={ancestorId}
          name={languageContext("category")}
          value={selected ?? 0}
          onChange={onCategoryChange}
          options={[
            { value: 0, label: languageContext("all") },
            ...children.map((child) => ({
              value: child.trainingCategoryId,
              label: child.categoryTitleTranslated,
            })),
          ]}
          languageContext={languageContext}
          className="filter-select-category"
          fullWidth={true}
          sx={sx}
        />
      </BaseGrid>
    );
  });

  if (!selects[0]) return null;

  return <>{selects}</>;
};

export default SelectFilterCategory;
